import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { CertificateProvider } from './context/CertificateContext';
import { ActivityProvider } from './context/ActivityContext';
import { VerifiedDBProvider } from './context/VerifiedDBContext';
import { DatabaseProvider } from './context/DatabaseContext';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import LandingPage from './pages/LandingPage';
import UploadPage from './pages/UploadPage';
import CheckPage from './pages/CheckPage';
import AdminDashboard from './pages/AdminDashboard';
import DatabaseAdmin from './pages/DatabaseAdmin';
import SPOCDashboard from './pages/SPOCDashboard';
import HRDashboard from './pages/HRDashboard';
import HRVerifyPage from './pages/HRVerifyPage';
import HRSearchPage from './pages/HRSearchPage';
import StudentDashboard from './pages/StudentDashboard';
import TestSupabase from './pages/TestSupabase';
import AuthListener from './components/AuthListener';
import './App.css';

// Import test to run on startup
import './services/testSupabaseInsert';

function App() {
  return (
    <DatabaseProvider>
      <VerifiedDBProvider>
        <ActivityProvider>
          <CertificateProvider>
            <Router>
              <AuthListener />
              <div className="App">
                <Routes>
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegisterPage />} />
                  <Route path="/upload" element={<UploadPage />} />
                  <Route path="/check" element={<CheckPage />} />
                  <Route path="/admin" element={<AdminDashboard />} />
                  <Route path="/database" element={<DatabaseAdmin />} />
                  <Route path="/spoc-dashboard" element={<SPOCDashboard />} />
                  <Route path="/hr-dashboard" element={<HRDashboard />} />
                  <Route path="/hr/verify" element={<HRVerifyPage />} />
                  <Route path="/hr/search" element={<HRSearchPage />} />
                  <Route path="/student-dashboard" element={<StudentDashboard />} />
                  <Route path="/test-supabase" element={<TestSupabase />} />
                  <Route path="*" element={<Navigate to="/login" replace />} />
                </Routes>
              </div>
            </Router>
          </CertificateProvider>
        </ActivityProvider>
      </VerifiedDBProvider>
    </DatabaseProvider>
  );
}

export default App;
